import React from 'react';
import { Package } from 'lucide-react';
import { useLanguage } from '../../../../contexts/LanguageContext';

type Props = {
  packageName: string;
  pilgrimType: string;
  nusukGroup: string;
};

export const PackageInfo = ({ packageName, pilgrimType, nusukGroup }: Props) => {
  const { translations } = useLanguage(); // Access translations

  return (
    <td className="px-6 py-4">
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <Package size={16} className="text-primary-500" />
          <span className="font-medium">{packageName}</span>
        </div>
        <div className="text-sm text-gray-600">
          {translations?.packageInfo?.pilgrimType || 'Pilgrim Type'}: {pilgrimType}
        </div>
        <div className="text-sm text-gray-600">
          {translations?.packageInfo?.nusukGroup || 'Nusuk Group'}: {nusukGroup}
        </div>
      </div>
    </td>
  );
};
